import { Navigate, Outlet } from "react-router-dom"
import { useUser } from "@/hooks/useUser"
import Header from "@/components/Header"

export default function PimpinanLayout() {
  const { user, isPending } = useUser()
  const userRoles = user?.jenis_user || []
  const pimpinan = userRoles.includes("pimpinan")

  if (!isPending && !pimpinan) return <Navigate to={"/"} />

  return (
    <main className="flex">
      <section className="flex-1 overflow-x-auto p-5 min-h-screen">
        <Header />
        <Outlet />
      </section>
    </main>
  )
}
